// Shared responsive breakpoints (px). MOBILE_MAX_WIDTH gates mobile menu and
// drawer auto-close behaviour across the header/sidebar components — previously
// the literal 800 was duplicated in several files.
export const MOBILE_MAX_WIDTH = 800;
